import {useState, useEffect} from 'react';
import Stack from 'react-bootstrap/Stack';

const ResultBarcard = (props) => {
    const [batteryState, setBatteryState] = useState(10);

    useEffect(()=>{
        if(props.value){
            window.setTimeout(() => {
                setBatteryState(props.value)
            }, props.delay ? props.delay : 500)
        }
    },[]);

    return (
        <Stack gap={props.gap ? props.gap : 2} direction="horizontal" className="batteryCard">
            <div className="batteryStateWrapper">
                <div className="batteryState" style={{height: batteryState + '%'}}>
                    {props.icon && <img className="batteryIcon" src={props.icon} />}
                </div>
            </div>
            <div className="batteryInfo">
                <div className="batteryState">{props.textValue ? props.textValue : props.value} <small>{props.suffix ? props.suffix : "%"}</small></div>
                <div className="batteryTitle">{props.title}</div>
                <div className="batteryDescription">{props.description}</div>
            </div>
        </Stack>
    )
}

export default ResultBarcard;